module.exports = __webpack_public_path__ + "static/img/仪表盘_dashboard-one.3e0c286.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/imgs/newHome/仪表盘_dashboard-one.png
// module id = WF8R
// module chunks = 1